import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import useToken from '../../Components/Customer/useToken';
import useAccount from '../../Components/Customer/useAccount';
import Term from '../../Components/Term';
import Header from '../../Components/Customer/Header';
function Terms(props) {
  const { account, setAccount } = useAccount();
  const [serviceType, setServiceType] = useState(props.service_type ? props.service_type : 'ac-qd');
  const { token, setToken } = useToken();
  let navigate = useNavigate();

  const handleLogin = () => {
    navigate("/home");
  }
  const handleDashboard = () => {
    navigate("/home");
  }

  const logout = () => {
    setToken('')
    setAccount('')
   sessionStorage.removeItem("token");
   sessionStorage.removeItem("account_details");
}



  return (

    <div className="">
        <Header  clickLogout={logout} 
     serviceType={null}
     setServiceType={setServiceType}
     globalServiceTypes={props.globalServiceTypes}
     account={account}
    />





     


      <section className='bg-slate sm:max-w-full pt-7 pb-7'>
        <div className='container md:mx-auto bg-white w-full rounded  p-4 mt-7 shadow-xl'>
        <Term readMoreAvailable={false} />
        </div>
      </section>




    </div>

  )
}

export default Terms